import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Signin from './pages/signin/Signin';
import Game from './pages/game/Game';
import Leaderboard from './pages/leaderboard/Leaderboard';
import Profile from './pages/profile/Profile';
import './App.css';
import ThreeDCube from './components/3dcube/ThreeDCube';

const App = () => {
  const [currentUser, setCurrentUser] = useState(null)
  
  useEffect(()=>{
    setCurrentUser(JSON.parse(localStorage.getItem('currentUser')))
  },[localStorage.getItem('currentUser')])

  return (
    <Router>
      <div className='App'>
        <Routes>
          <Route path="/" element={currentUser ? <Navigate to="/game" /> : <Signin />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/game" element={<Game />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
        {/* <div>
          <ThreeDCube/>
        </div> */}
      </div>
    </Router>
  );
}

export default App;
